import Store from '../Store';
import structureQuantity from '../../data/ressources/ProductionOrdersQuantity';
import structureBatch from '../../data/ressources/ProductionOrdersBatch';

const localUserData = localStorage.getItem('userData') || '';
const userData = localUserData ? JSON.parse(localUserData) : '';

const ProductionOrderStore = new Store(`production/ordersbyuser/${userData?.user?.id || ''}`, { quantity: structureQuantity, batch: structureBatch });

export {ProductionOrderStore};